import { BootState } from "../states/boot";
import { IAppBooted } from "../../models/boot";
import { EBootActions, BootActions } from "../actions/boot";

export function BootReducers(
  state: IAppBooted = BootState,
  action: BootActions,
): IAppBooted {
  switch (action.type) {
    case EBootActions.BootAttempt: {
      return {
        ...state,
        status: false,
      };
    }
    case EBootActions.BootAttemptSuccess: {
      return {
        ...state,
        status: true,
        errors: [],
      };
    }
    case EBootActions.BootAttemptFailed: {
      return {
        ...state,
        status: action.payload.status,
        errors: action.payload.errors,
      };
    }
    default:
      return state;
  }
}
